var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeafTickShadow = function SvgLeafTickShadow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 53,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E4E5E4",
    fillOpacity: 0.5,
    d: "M26 50.694c12.477 0 22.592-3.454 22.592-7.714S38.477 35.265 26 35.265 3.408 38.72 3.408 42.98 13.523 50.694 26 50.694"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#28C382",
    d: "M13.663 30.46c6.065 7.434 15.303 8.154 22.549 1.998C43.458 26.3 39.826 14.906 54 4.158 34.607-3.635 23.642.847 16.52 6.896c-7.123 6.048-8.922 16.13-2.857 23.564"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#035F48",
    d: "M10.807 44.717c-3.79-5.814-5.5-8.677-9.15-12.061-.723-.666 0-1.188.952-1.404 1.322-.288 1.992-.288 2.38 0 2.962 2.268 3.879 4.176 7.052 8.46C16.695 22.612 26.004 14.06 35.79 9.11c.881-.45 1.868.36 1.093.954C25.565 18.328 17.69 30.62 14.809 44.52c0 .252-.353.414-.6.468a8.6 8.6 0 0 1-2.873.108.79.79 0 0 1-.529-.378"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h54v52.898H0z"
  })))));
};
export default SvgLeafTickShadow;